import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { THLBoardInfoActionType } from './hl-board.models';
import * as HLBoardActions from './hl-board.actions';
import { of, from } from 'rxjs';
import { switchMap, map, catchError, take, finalize, exhaustMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class HlBoardEffects {
  constructor(
    private actions$: Actions,
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  getHLBoardList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(THLBoardInfoActionType.GetHLBoardList),
      exhaustMap((action: HLBoardActions.GetHLBoardList) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          switchMap((loaderEl) =>
            this.plani8DataService.getHLBoardList(action.payload).pipe(
              map((res) => new HLBoardActions.GetHLBoardListSuccess(res)),
              catchError(() => of(new HLBoardActions.GetHLBoardListFailure())),
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
            ),
          ),
        ),
      ),
    ),
  );

  getOPLCapacitiesInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(THLBoardInfoActionType.GetOTLCapacitiesInfo),
      switchMap((action: HLBoardActions.GetOTLCapacitiesInfo) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.plani8DataService.getOTLCapacitiesInfo(action.payload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          map((res) => new HLBoardActions.GetOTLCapacitiesInfoSuccess(res)),
          catchError(() => {
            return of(new HLBoardActions.GetOTLCapacitiesInfoFailure());
          }),
        ),
      ),
    ),
  );

  getWeeklyOTLCapacitiesInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(THLBoardInfoActionType.GetWeeklyOPLCapacitiesInfo),
      switchMap((action: HLBoardActions.GetWeeklyOPLCapacitiesInfo) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.plani8DataService.getWeeklyOPLCapacitiesInfo(action.payload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          map((res) => new HLBoardActions.GetWeeklyOPLCapacitiesInfoSuccess(res)),
          catchError(() => {
            return of(new HLBoardActions.GetWeeklyOPLCapacitiesInfoFailure());
          }),
        ),
      ),
    ),
  );

  getDailyOTLCapacitiesInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(THLBoardInfoActionType.GetDailyOPLCapacitiesInfo),
      switchMap((action: HLBoardActions.GetDailyOPLCapacitiesInfo) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.plani8DataService.getDailyOPLCapacitiesInfo(action.payload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          map((res) => new HLBoardActions.GetDailyOPLCapacitiesInfoSuccess(res)),
          catchError(() => {
            return of(new HLBoardActions.GetDailyOPLCapacitiesInfoFailure());
          }),
        ),
      ),
    ),
  );
}
